import { Skeleton } from "@chakra-ui/react";
import { NavBar } from "@src/components/ui-kit";
import { Icon } from "@src/components/ui-kit/Icon";
import { AppSubNav } from "@src/components/widgets/AppSubNav/AppSubNav";
import { useProformaInvoiceNavigation } from "@src/components/widgets/AppSubNav/navigation-invoices/proforma-invoices/hooks";
import { useScreenType } from "@src/utils/hooks/useIsMobile";

type NavigationProformaInvoiceProps = {
  invoiceId?: string;
};
export const NavigationProformaInvoice = ({
  invoiceId,
}: NavigationProformaInvoiceProps) => {
  const { visiblePages, isLoading, activePage, activeSubpage } =
    useProformaInvoiceNavigation(invoiceId);
  const { isDesktop } = useScreenType();
  const isEdit =
    !!activeSubpage && activeSubpage.href.pathname.includes("/edit");
  const detailPage = activePage?.subPages?.find((subpage) =>
    subpage.href.pathname.includes("/detail"),
  );

  return (
    <AppSubNav>
      {visiblePages.map((page) => (
        <NavBar.Item key={page.href.pathname} active={false} href={page.href}>
          {page.title()}
        </NavBar.Item>
      ))}

      {isDesktop && isEdit && <Icon name="chevron-right" />}

      {isEdit && detailPage && (
        <NavBar.Item active={false} href={detailPage.href}>
          {detailPage.title()}
        </NavBar.Item>
      )}

      {isDesktop && activeSubpage && <Icon name="chevron-right" />}

      {activeSubpage && (
        <NavBar.Item active={false} href={activeSubpage.href}>
          <Skeleton isLoaded={!isLoading}>{activeSubpage.title()}</Skeleton>
        </NavBar.Item>
      )}
    </AppSubNav>
  );
};
